<div class="row mx-0 h-100" (click)="disableContextMenu()">
  <div class="col-12 my-2">
    <div class="row mx-0 w-100">
      <div class="col-12 p-0">
        <span>{{ "Gestione TV" | translate }}</span>
        <h3 class="color-theme font-weight-bold">
          {{ "TV" | translate }} ({{tvs.length}})
        </h3>
      </div>
    </div>
    <div class="row mx-0 w-100">
      <div class="form-group col-3 p-0">
        <div>
          <label for="search">{{ "Cerca" | translate }}:</label>
          <input id="search" [(ngModel)]="searchValue" />
        </div>
      </div>
      
      <div class="col-4 col-lg-5 col-xl-7 form-group d-flex justify-content-end">
        <div class="mr-2">
          <label for="">VirtualCast Checkin Checkout</label>
          <div class="form-check">
              <input
                [disabled]="false"
                class="form-check-input"
                type="radio"
                name="projectType"
                id="projectTypePremium"
                [value]="'automatico'"
                [(ngModel)]="virtualCastSelected"
              />
              <label class="form-check-label" for="projectTypePremium"> {{"Automatico" | translate}} </label>
          </div>
          <div class="form-check">
              <input
                [disabled]="false"
                class="form-check-input"
                type="radio"
                name="projectType"
                id="projectTypePremium"
                [value]="'manuale'"
                [(ngModel)]="virtualCastSelected"
              />
              <label class="form-check-label" for="projectTypePremium"> {{"Manuale" | translate}} </label>
          </div>
          <div class="form-check">
              <input
                [disabled]="true"
                class="form-check-input"
                type="radio"
                name="projectType"
                id="projectTypePremium"
                [value]="'pms'"
                [(ngModel)]="virtualCastSelected"
              />
              <label class="form-check-label" for="projectTypePremium"> {{"PMS" | translate}} </label>
            </div>
        </div>
      </div>

      <div *ngIf="accountService.isAdmin" class="col-4 col-sm-4 col-ml-4 col-xl-2 p-0">
        <button class="btn btn-primary mb-4 w-100" (click)="editTv('')">
          + {{ "Aggiungi tv" | translate }}
        </button>
        <button class="btn btn-primary mb-4 w-100" (click)="listMacAddress()">
          Mac Address list
        </button>
      </div>
      
    </div>

    <div class="row mx-0">
      <div class="card w-100">
        <div class="card-body" style="overflow-y: auto">
          <table
            class="table"
            (contextmenu)="onrightClick($event)"
            oncontextmenu="return false;"
          >
            <thead>
              <tr>
                <th scope="col">{{ "Nome" | translate }}</th>

                <th scope="col">{{ "Mac Address" | translate }}</th>

                <th scope="col">{{ "Modello" | translate }}</th>

                <th scope="col">{{ "Seriale" | translate }}</th>

                <th scope="col">{{ "Check In" | translate }}</th>

                <th scope="col">{{ "Check Out" | translate }}</th>

                <th scope="col">{{ "Guests" | translate }}</th>

                <th scope="col-1">{{ "Visibile" | translate }}</th>

                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                oncontextmenu="return false;"
                *ngFor="let tv of tvs | filter : searchValue"
                (contextmenu)="
                  onrightClick($event, tv, true); $event.stopPropagation()
                "
                style="cursor: pointer"
              >
                <td
                  (click)="editTv(tv.id)"
                  style="
                    border-left: 1px solid rgba(0, 0, 0, 0.125);
                    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
                  "
                >
                  {{ tv.roomnumber }}
                </td>

                <td style="border-bottom: 1px solid rgba(0, 0, 0, 0.125)">
                  {{ tv.macaddress }}
                </td>

                <td style="border-bottom: 1px solid rgba(0, 0, 0, 0.125)">
                  {{ tv.model }}
                </td>

                <td style="border-bottom: 1px solid rgba(0, 0, 0, 0.125)">
                  {{ tv.serial }}
                </td>

                <td style="border-bottom: 1px solid rgba(0, 0, 0, 0.125)">
                  {{ tv.checkin | date: 'dd/MM/yyyy HH:mm'}}
                </td>

                <td style="border-bottom: 1px solid rgba(0, 0, 0, 0.125)">
                  {{ tv.checkout | date: 'dd/MM/yyyy HH:mm'}}
                </td>

                <td class="text-center" style="border-bottom: 1px solid rgba(0, 0, 0, 0.125)">
                  {{ tv.surnameguest  || '-'}}
                </td>

                <td style="border-bottom: 1px solid rgba(0, 0, 0, 0.125); text-align: center;" (click)="handlerToggleVisible(tv)">
                  <img
                  [src]="tv.visible ? 'assets/img/Pittogramma Visibile.png' : 'assets/img/Pittogramma Nascondi.png'"
                  alt=""
                  style="width: 30px"
                />
                </td>

                <td
                  style="
                    border-right: 1px solid rgba(0, 0, 0, 0.125);
                    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
                    padding: 0;
                    width: 10%;
                  "
                >
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: flex-end;
                      width: 100%;
                    "
                  >
                    <div class="modifyImg" (click)="editTv(tv.id)">
                      <img
                        src="assets/img/Pittogramma modifica.png"
                        style="width: 30px"
                        alt=""
                      />
                    </div>
                    <div
                      data-toggle="modal"
                      data-target="#delConfirmModal"
                      class="deleteImg"
                      (click)="tvToDelete = tv"
                    >
                      <img
                        src="assets/img/Pittogramma elimina - cestino.png"
                        style="width: 30px"
                        alt=""
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="delConfirmModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="delConfirmModal"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">
          {{ "Confermare eliminazione" | translate }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{
          "Continuare con l'operazione? Ricordiamo che i dati eliminati non si potranno recuperare"
            | translate
        }}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">
          {{ "Annulla" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          data-dismiss="modal"
          (click)="deleteTv()"
        >
          {{ "Conferma" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
